import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppConstant } from 'src/app/config/app.constant';
import { AdminService } from 'src/app/services/admin.service';
import { AppStateProvider } from 'src/app/services/app-state.provider';

export class EmailTemplate {
  fromId: string;
  toId: string;
  subject: string;
  body: string;
}

@Component({
  standalone: false,
  selector: 'app-email-companies',
  templateUrl: './email-companies.component.html',
  styleUrls: ['./email-companies.component.scss'],
})
export class EmailCompaniesComponent implements OnInit {
  meetingNav: { index: string; name: string; link: string }[];
  emailList: string;
  show: boolean;
  token: string;
  url: string;
  memberDetail: any;
  subject;
  body;
  member: any;
  fromId: string;
  at: string;
  sub: string;
  content: string;
  constructor(
    private router: Router,
    private appStateSrv: AppStateProvider,
    private adminSrv: AdminService
  ) { }

  ngOnInit(): void {
    this.emailList = localStorage.getItem(AppConstant.localStorage.emailId);
    this.fromId = JSON.parse(localStorage.getItem(AppConstant.localStorage.userDetails)).adminEmailId;
    console.log(this.fromId);

    this.meetingNav = [
      {
        index: '1',
        name: 'Companies',
        link: 'companies/companies-list/email',
      },
    ];

    const route = {
      index: '1',
      name: 'Companies',
      link: 'companies/companies-list/email',
    };
    this.appStateSrv.setSideNavState(route);
  }

  sendemail() {

    //both not defined and not touched
    if (this.subject == undefined && this.body == undefined) {
      alert('Subject and Body can not be empty');
      return;
    }
    // sub present but not body touched
    if (this.subject !== undefined && this.body == undefined) {
      if (this.subject.length > 4000) {
        alert('subject too long!!');
        return;
      }
      if (this.subject.length !== undefined && this.subject.length !== 0) {
        alert('Body can not be empty');
        return;
      }
      alert('Subject and Body can not be empty');
      return;
    }
    //body present not sub touched
    if (this.body !== undefined && this.subject == undefined) {
      if (this.body.length !== undefined && this.body.length !== 0) {
        alert('Subject can not be empty');
        return;
      }
      alert('Subject and Body can not be empty');
      return;
    }
    if (this.subject !== undefined && this.body !== undefined) {
      if (this.subject.length == 0 && this.body.length == 0) {
        alert('Subject and Body can not be empty');
        return;
      }
      if (this.subject.length == 0) {
        alert('Subject can not be empty');
        return;
      }
      if (this.body.length == 0) {
        alert('body can not be empty');
        return;
      }
    }

    let temp = new EmailTemplate();
    temp.fromId = this.fromId;
    temp.subject = this.subject;
    temp.body = this.body;
    temp.toId = this.emailList;

    this.adminSrv.sendEmail(temp).subscribe((response) => {
      console.log('response email ', response);
      history.back();
    });
  }

  cancel() {
    this.router.navigate(['companies/companies-list']);
  }
}
